/** @jsxImportSource @emotion/react */
import { useState, useEffect } from "react";
import { accessAPI, formatFecha, TablaFiltrable } from "../../shared";
import { Titulo } from "../../shared";

import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Skeleton } from "primereact/skeleton";
import { Tag } from "primereact/tag";

export default function ActividadesTerminadas() {
  const [actividades, setActividades] = useState([]);
  const [loading, setLoading] = useState(true);
  const [globalFilter, setGlobalFilter] = useState("");

  useEffect(() => {
    accessAPI(
      "GET",
      "colab/actividad/terminadas",
      null,
      (respuesta) => {
        setActividades(respuesta);
        setLoading(false);
      },
      () => {
        setLoading(false);
      }
    );
  }, []);

  if (loading) {
    return (
      <>
        <Skeleton
          width="22em"
          height="2.1em"
          css={{ marginBottom: "1.1em", marginTop: "1em" }}
        />
        <Skeleton width="100%" height="20em" />
      </>
    );
  }

  return (
    <>
      <Titulo>Actividades terminadas</Titulo>
      <Card>
        <div css={{ display: "flex", justifyContent: "flex-end", marginBottom: "0.5em" }}>
          <span className="p-input-icon-left" css={{ width: "33%", "& .pi-search": { left: "0.75rem" }, "@media (max-width: 768px)": { width: "100%" } }}>
            <i className="pi pi-search" />
            <InputText
              value={globalFilter}
              onChange={(e) => setGlobalFilter(e.target.value)}
              placeholder="Buscar..."
              css={{ width: "100%", paddingLeft: "2.5rem" }}
            />
          </span>
        </div>
        <TablaFiltrable conFiltros={false}
          value={actividades}
          paginator
          rows={10}
          globalFilter={globalFilter}
          emptyMessage="No hay actividades terminadas"
          size="small"
          stripedRows
          selectionMode="single"
          onRowSelect={(e) =>
            window.open(
              `/actividad/${e.data.id}?volver=/terminadas`,
              e.originalEvent.metaKey || e.originalEvent.ctrlKey
                ? "_blank"
                : "_self"
            )
          }
          css={{
            "& .p-datatable-tbody > tr": {
              cursor: "pointer",
            },
          }}
        >
          <Column
            field="actividad.proceso.cliente.razonsocial"
            header="Cliente"
          />
          <Column
            header="Proceso"
            body={(row) =>
              `${row.actividad.proceso.nombre} - ${row.actividad.proceso.nombrefantasia}`
            }
          />
          <Column
            header="Actividad"
            body={(row) =>
              `${row.actividad.actividadtipo.nombre} - ${row.nombre}`
            }
          />
          <Column
            field="fechaCierre"
            header="Fecha de cierre"
            body={(row) =>
              row.fechaCierre
                ? formatFecha(row.fechaCierre)
                : "-"
            }
          />
          <Column
            header=""
            body={(row) =>
              row.enFormacion ? (
                <Tag
                  value="En formación"
                  css={{
                    backgroundColor: "var(--amarillo)",
                    color: "white",
                    fontSize: "0.8rem",
                  }}
                />
              ) : null
            }
            style={{ width: "120px" }}
          />
        </TablaFiltrable>
      </Card>
    </>
  );
}
